import React from "react";
import ourServices1 from "../images/service-1.svg";
import ourServices2 from "../images/service-2.svg";
import ourServices3 from "../images/service-3.svg";
import LeftRightCombo from "../common/LeftRightCombo";
import CircleRightTop from "../images/EllipseTeamTopLeft.png";
import CircleLeftBottom from "../images/EllipseRightBottom.png";
import { useTranslation } from "react-i18next";

const OurServicesMain = () => {
    const { t } = useTranslation();
    const data = [
        {
            topBtnText: t("service_consulting"),
            mainTitle: t("service_consulting_title"),
            subTitle: t("service_consulting_desc"),
            image: ourServices1,
            buttonText: t("get_started"),
            buttonTextNavigate: "/contact-us",
        },
        {
            topBtnText: t("solution_integration"),
            mainTitle:
                t("solution_integration_title"),
            subTitle:
                t("solution_integration_desc"),
            image: ourServices2,
            buttonText: t("get_started"),
            buttonTextNavigate: "/contact-us",
        },
        {
            topBtnText: t("support_management"),
            mainTitle:
                t("support_management_title"),
            subTitle:
                t("support_management_desc"),
            image: ourServices3,
            buttonText: t("get_started"),
            buttonTextNavigate: "/contact-us",
        },
        // {
        //   topBtnText: "Vulnerability Scanning",
        //   mainTitle:
        //     "Stay One Step Ahead Of Potential Threats With Our Automated Vulnerability Scanners ",
        //   subTitle:
        //     "Continuously monitoring your projects, to identify and flag any vulnerabilities. With instant notifications and detailed reports, you can quickly address any security weaknesses and strengthen the overall security of your platform",
        //   image: ourServices4,
        //   buttonText: "Get Started",
        //   // buttonTextNavigate: "/contact-us",
        // },
    ];
    return (
        <div className="mt-[90px] md:mt-[110px] sm:mt-28 flex justify-center">
            <div className="xl:max-w-[1000px] 3xl:max-w-[1200px]">
                <div className="aboutUs_main">
                    <img draggable="false"
                        src={CircleRightTop}
                        className="back_circle1About"
                        alt="back_circle1"
                    />
                    <img draggable="false"
                        src={CircleLeftBottom}
                        className="back_circle2About"
                        alt="back_circle2"
                    />
                </div>
                <div className="md:container md:mx-auto mt-[20px] ">
                    <div className="text-[#141619] text-[20px]  md:text-[35px] 3xl:text-[54px] font-[600] flex flex-col justify-center items-center">
                        <span className="md:leading-[63px]">
                            {t("our_services")}
                        </span>
                    </div>
                </div>
                {data &&
                    data.map((item, index) => {
                        return (
                            <LeftRightCombo
                                key={index}
                                mainTitle={item.mainTitle}
                                subTitle={item.subTitle}
                                image={item.image}
                                buttonText={item.buttonText}
                                index={index}
                                topBtnText={item.topBtnText}
                                buttonTextNavigate={item.buttonTextNavigate}
                                pageTitle="company-overview"
                            />
                        );
                    })}
            </div>
        </div>
    );
};

export default OurServicesMain;
